module.exports = __webpack_public_path__ + "static/media/silver.3665b205.png";